// ============================================================================
// El catálogo de derechos que ve ESTA plataforma (catálogo v24).
// ============================================================================
// `@torre/entitlements` trae el catálogo común de CC-CONSOLE y WAYAK, con las
// llaves de los dos forks. Lo que pinta esta app (sidebar, guardia de rutas,
// editores de licencias y roles) trabaja sobre la VISTA de esta plataforma
// (`catalogFor`): sin lo que llegó del otro fork sin código aquí y con el status
// de aquí. Así se ve exactamente lo que se veía con el catálogo propio.
//
// Este archivo es lo único que difiere entre los forks: cada uno nombra su
// plataforma. Importa el catálogo de aquí, no de `@torre/entitlements`.
// ============================================================================
import { CATALOG as COMMON_CATALOG, catalogFor, type EntitlementNode, type TenantId } from "@torre/entitlements";

/** Esta plataforma (`packages/entitlements/src/tenantDefaults.ts`). */
export const ENTITLEMENTS_TENANT: TenantId = "wayak";

/** El catálogo de esta plataforma. */
export const CATALOG: readonly EntitlementNode[] = catalogFor(COMMON_CATALOG, ENTITLEMENTS_TENANT);
